import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Player } from "@lottiefiles/react-lottie-player";
import loaderAnim from "../../assets/icons/SubmitOrder.json";
import Cookies from "js-cookie";

const SnackBar = () => {
  const l = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();
  const [show, setshow] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setshow(false);
    }, 4000);
  }, []);

  return (
    <div
      className={`fixed z-40  bottom-1/2 left-1 right-1 md:left-1 mx-8 lg:mx-auto w-9/12 md:w-1/3 h-56`}
    >
      {!show && (
        <>
          <div className="flex flex-col px-6 py-2 bg-white border shadow-md hover:shodow-lg rounded-2xl">
            <div className="flex items-center justify-between">
              <div className="items-center p-5 mx-auto">
                <Player
                  src={loaderAnim}
                  autoplay
                  loop
                  className="w-56 md:w-96 player"
                />
                <div className="flex flex-col ml-3">
                  <div className={`font-medium leading-none text-center  ${l}`}>
                    {t("shopoingCompletedSuccessfully")}
                  </div>
                  <p className={`text-sm text-center my-3 mx-auto ${l}`}>
                {t("thankYouForChoosingVary")}
              </p>
                </div>
              </div>
              {/* <button className="px-5 py-2 ml-4 text-sm font-medium tracking-wider text-white bg-red-500 border-2 border-red-500 rounded-full shadow-sm flex-no-shrink hover:shadow-lg">
            Delete
          </button> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SnackBar;
